/**
 * Extracts page_type and page_sub_type from the current URL path.
 *
 * Logic:
 * - If the first two segments of the path are numbers, treat it as the "home" page.
 * - Otherwise:
 *    - page_type = first non-empty folder (e.g., "player", "team")
 *    - page_sub_type = last non-number folder before any numeric IDs
 *
 * Notes:
 * - Handles normal URLs, IDs, and the homepage fallback case.
 */

export const findPageContext = (pathname) => {
  const parts = pathname.split('/').filter(Boolean); // split and remove empty segments

  if (parts.length === 0) {
    // No parts at all ("/")
    return {
      page_type: 'unknown',
      page_sub_type: null,
    };
  }

  // Special case: Home page if first two segments are numbers
  if (/^\d+$/.test(parts[0]) && /^\d+$/.test(parts[1])) {
    return {
      page_type: 'home',
      page_sub_type: null,
    };
  }

  let page_sub_type = null;
  let foundNumber = false;

  // Walk through remaining parts to find last non-numeric segment
  parts.slice(1).forEach((part) => {
    if (foundNumber) return; // already hit a number, skip
    if (/^\d+$/.test(part)) {
      foundNumber = true; // first number found, stop capturing
    } else {
      page_sub_type = part; // keep updating until first number
    }
  });

  return {
    page_type: parts[0] || 'unknown', // first segment
    page_sub_type: page_sub_type || null, // last static part before numbers
  };
};
